import React, { useState } from 'react'
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DropdownContainer } from "web/pages/private/CommonPages/DashBoard/DashBoardStyled";
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import HoverRightArrow from "web/assets/images/dropdown-menu-hover-arrow.png";
export function BuyerCategories(props) {
  let history = useHistory();
  let dispatch = useDispatch();
  const [dropdownOpen, setOpen] = useState(false);
  const toggle = (e) => {
    setOpen(!dropdownOpen);
  }
  const pageLanguageContents = props.contents
  
  const storedData = useSelector(
    (state) => state.storedData.payload
  );
  let disableFlg = storedData?.guestUser

  return (
    <DropdownContainer
      className={`type-ahead-search-input dropdown-wrapper`}
    >
      <ButtonDropdown isOpen={dropdownOpen} toggle={toggle} direction="left">
        <DropdownToggle caret></DropdownToggle>
        <DropdownMenu className="buyer-categories-menu">
          <DropdownItem
            onClick={() => {
              props.advanceSearchClick();
            }}
          >
            <img
              className="arrow-image"
              src={HoverRightArrow}
              alt="right-arrow"
            />{" "}
            {pageLanguageContents?.Buy_Arrow[3]?.Advance_Search}
          </DropdownItem>
          <DropdownItem
            onClick={() => {             
              history.push({
                pathname: "/nearby-inventory",
                postType: "PostInventory",
              });
            }}
          >
            <img
              className="arrow-image"
              src={HoverRightArrow}
              alt="right-arrow"
            />
         Search Available Inventory
          </DropdownItem>    

          {!disableFlg && <DropdownItem
            onClick={() => {
              let obj = {
                type: "PostLoad",
                activePage: "PostLoad",
                activeSearch: "Dashboard",
                expanded: 'panel1'
              }
              dispatch({ type: 'POST_LOAD_URL', payload: obj })
              history.push({
                pathname: "/post-my-pallet-needs",
              });
            }}
          >
            <img
              className="arrow-image"
              src={HoverRightArrow}
              alt="right-arrow"
            />
            {pageLanguageContents?.Buy_Arrow[6]?.PostLoad}
          </DropdownItem>}
          {!disableFlg && <DropdownItem
            onClick={() => {
              let paginationObj = {
                selectedPage: 1,
              }
              dispatch({ type: 'BIDS_PAGINATION', payload: paginationObj })
              let obj = {
                postType: "PostLoad",
                type: "postedNeeds",
                activePage: "PostLoad",
                activeSearch: 'Dashboard',
                expanded: 'panel1'
              }
              dispatch({ type: 'CREATED_NEEDS', payload: obj })

              history.push({
                pathname: "/my-posted-pallet-needs",
              });
            }}
          >
            <img
              className="arrow-image"
              src={HoverRightArrow}
              alt="right-arrow"
            />
            {pageLanguageContents?.Buy_Arrow[4]?.Needs}
          </DropdownItem>}

          <DropdownItem
            onClick={() => {
              let obj = {
                postType: "PostInventory",
                type: "bidsPalletOffers",
                activePage: "PostInventory",
                activeSearch: 'Dashboard',
                expanded: 'panel1'
              }
              dispatch({ type: 'BIDS_INVENTORY', payload: obj })

              history.push({
                pathname: "/view-my-offers-on-pallet-inventory",
              });
            }}
          >
            <img
              className="arrow-image"
              src={HoverRightArrow}
              alt="right-arrow"
            />
            {pageLanguageContents?.Buy_Arrow[5]?.Bids_Offers}
          </DropdownItem>

        </DropdownMenu>
      </ButtonDropdown>
    </DropdownContainer>
  );
}

export function SellerCategories(props) {
  let history = useHistory();
  let dispatch = useDispatch();
  const [dropdownOpen, setOpen] = useState(false);
  const pageLanguageContents = props.contents
  const toggle = (e) => {
    setOpen(!dropdownOpen);
  }

  return (
    <DropdownContainer className={`type-ahead-search-input dropdown-wrapper`}>
      <ButtonDropdown isOpen={dropdownOpen} toggle={toggle} direction="left">
        <DropdownToggle caret></DropdownToggle>
        <DropdownMenu className="seller-categories-menu">
          <DropdownItem
            onClick={() => {
              props.advanceSearchClick();
            }}
          >
            <img
              className="arrow-image"
              src={HoverRightArrow}
              alt="right-arrow"
            />
            {pageLanguageContents?.Sell_Arrow[3]?.Advance_Search}
          </DropdownItem>
          <DropdownItem
            onClick={() => {             
              history.push({
                pathname: "/nearby-needs",
                postType: "PostLoad",
              });
            }}
          >
            <img
              className="arrow-image"
              src={HoverRightArrow}
              alt="right-arrow"
            />
           Search Posted Needs
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              let obj = {
                type: "PostInventory",
                activePage: "PostInventory",
                activeSearch: "Dashboard",
                expanded: 'panel2'
              }
              dispatch({ type: 'POST_INVENTORY_URL', payload: obj })
              history.push({
                pathname: "/post-my-pallet-inventory",
                //search: "?type=PostInventory&activePage=PostInventory&activeSearch=Dashboard&expanded=panel2",
              });
            }}
          >
            <img
              className="arrow-image"
              src={HoverRightArrow}
              alt="right-arrow"
            />
            {pageLanguageContents?.Sell_Arrow[6]?.PostInventory}
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              let obj = {
                postType: "PostInventory",
                type: "palletOffers",
                activePage: "PostInventory",
                activeSearch: 'Dashboard',
                expanded: 'panel2'
              }
              dispatch({ type: 'CREATED_INVENTORY', payload: obj })
              history.push({
                pathname: "/my-posted-pallet-inventory",
                //search: "?postType=PostInventory&type=palletOffers&activePage=PostInventory&activeSearch=Dashboard&expanded=panel2",
              });
            }}
          >
            <img
              className="arrow-image"
              src={HoverRightArrow}
              alt="right-arrow"
            />
            {pageLanguageContents?.Sell_Arrow[5]?.Needs}
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              let obj = {
                postType: "PostLoad",
                type: "bidsPalletNeeds",
                activePage: "PostLoad",
                activeSearch: 'Dashboard',
                expanded: 'panel2'
              }
              dispatch({ type: 'BID_NEEDS', payload: obj })

              history.push({
                pathname: "/view-my-bids-on-pallet-needs",
                //search: "?postType=PostLoad&type=bidsPalletNeeds&activePage=PostLoad&activeSearch=Dashboard&expanded=panel2",
              });
            }}
          >
            <img
              className="arrow-image"
              src={HoverRightArrow}
              alt="right-arrow"
            />
            {pageLanguageContents?.Sell_Arrow[4]?.Bid_Offers}
          </DropdownItem>


        </DropdownMenu>
      </ButtonDropdown>
    </DropdownContainer>
  );
}